
//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';

//```import constants types
import {
    COVERAGE_DETAILS_OPEN_MODAL,
    COVERAGE_DETAILS_REQUEST,
} from 'Redux/actionTypes';

import { endpoints } from 'Core/defaultValues';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { coverageDetailsGetDeviceResult, coverageDetailsResult } from 'Redux/actions';


function* getDevice({ payload }) {
    try {
        const QUERY = `
        query getUnit ($id: Int!) {
            result: getUnit (id: $id) {
                    id
                    label
                    unitConfig{
                        coverageScore
                        coverageUpdatedOn
                        coverageDetail
                    }
                }
        }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            { id: payload },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(coverageDetailsGetDeviceResult(data?.result))
        } else {
            yield put(coverageDetailsGetDeviceResult({ error: true }))
        }

    } catch (exc) {
        yield put(coverageDetailsGetDeviceResult({ error: true }))
        ExceptionManager(
            exc,
            "Modules/devices/.components/coverageDetails/redux/saga",
            "getDevice",
        )
    }
}

function* watchMethods() {
    yield takeEvery(COVERAGE_DETAILS_OPEN_MODAL, getDevice);
}



export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}